module.exports = __webpack_public_path__ + "img/answer_error.033afcdc.png";